import { setObjects } from '../helpers';

const initialState = () => ({
    storage: { },
})

const mutations = {
    ADD_PARTIALS (state, partials) {
        setObjects(partials, state.storage, { validated: false, submissions: [] } )
    },
    VALIDATE_PARTIAL (state, partialId, validated) {
        state.storage[partialId].validated = validated
    },
    ADD_SUBMISSION_TO_PARTIAL (state, partialId, submissionId) {
        const partial = state.storage[partialId]

        if ( partial.submissions.indexOf(submissionId) === -1) {
            partial.submissions.push(submissionId)
        }

    },
    REMOVE_SUBMISSION_FROM_PARTIAL (state, partialId, submissionId) {

        const partial = state.storage[partialId]
        const index = partial.submissions.indexOf(submissionId)

        if ( index  !== -1 ) {
            partial.submissions.splice(index, 1)
        }

    },
    SWAP_SUBMISSION_ID ( state, partialId, oldId, newId ) {

        const partial = state.storage[partialId]
        const index = partial.submissions.indexOf(oldId)

        if ( index  !== -1 ) {
            partial.submissions.splice(index, 1, newId)
        }

    }
}

export default {
    initialState,
    state: initialState(),
    mutations
}



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/partials.js